import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourceLineageCountsFragmentGql } from './DatasourceLineageCountsFragmentGql';

export const DatasourceLineageCountsFilteredByFieldQueryGql: DocumentNode = gql`
query DatasourceLineageCountsFilteredByFieldQuery($vizportalUrlId: String!, $selectedFieldId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...DatasourceLineageCountsFragment
    filteredFieldsConnection: fieldsConnection(filter: {id: $selectedFieldId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
          totalCount
        }
        upstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
${DatasourceLineageCountsFragmentGql}
`;
